export const redirectExploreProperties = (visitId: string, locale: string) => {
  const explorePropertiesRedirectUrl = `${process.env.REACT_APP_DALGONA_GW_API_URL}/visits/${visitId}/explore-more-properties/${locale}`;
  window.location.href = explorePropertiesRedirectUrl;
};
